import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import Lock from "@material-ui/icons/Lock";
import EmptyState from "./EmptyState";

const Title = styled.div`
  font-weight: 600;
  margin-bottom: 4px;
`;

const NoAccessState = ({ title, description, ...props }) => (
  <EmptyState {...props} icon={Lock}>
    <Title>{title}</Title>
    <div>{description}</div>
  </EmptyState>
);

NoAccessState.propTypes = {
  title: PropTypes.node,
  description: PropTypes.node,
};

NoAccessState.defaultProps = {
  title: "You don't have access to this RFQ",
  description:
    "You no longer have permission to view this RFQ. Contact your administrator if you think this is a mistake.",
};

export default NoAccessState;
